import { z } from 'zod';
import {
    COMPENSATORY_CONTROL_NATURES,
    COMPENSATORY_CONTROL_NATURE_PERMANENT,
    COMPENSATORY_CONTROL_NATURE_TEMPORARY,
} from './bigdes-compensatory-control.constants.js';

export const CompensatoryControlNatureSchema = z.enum(COMPENSATORY_CONTROL_NATURES);

const compensatoryControlBaseShape = {
    name: z.string({ required_error: 'form.validation.nameRequired', invalid_type_error: 'form.validation.nameRequired' }).trim().min(1, 'form.validation.nameRequired'),
    controlNo: z.string({ required_error: 'form.validation.controlNoRequired', invalid_type_error: 'form.validation.controlNoRequired' }).trim().min(1, 'form.validation.controlNoRequired'),
    definition: z.string({ required_error: 'form.validation.definitionRequired', invalid_type_error: 'form.validation.definitionRequired' }).trim().min(1, 'form.validation.definitionRequired'),
    nature: CompensatoryControlNatureSchema,
    plannedImplementationInterval: z.string().trim().optional().nullable(),
    relatedMeasureArticleNo: z.string().trim().optional().default(''),
    relatedMeasureRequirements: z.string().trim().optional().default(''),
    implementationRisks: z.string().trim().optional().default(''),
    nonImplementationReasons: z.string().trim().optional().default(''),
    verificationMethod: z.string().trim().optional().default(''),
};

function validateCompensatoryNature(data, ctx) {
    if (data.nature === COMPENSATORY_CONTROL_NATURE_TEMPORARY) {
        if (!data.plannedImplementationInterval?.trim()) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: 'form.validation.plannedImplementationIntervalRequired',
                path: ['plannedImplementationInterval'],
            });
        }
    }

    if (data.nature === COMPENSATORY_CONTROL_NATURE_PERMANENT) {
        data.plannedImplementationInterval = null;
    }
}

export const CreateBigdesCompensatoryControlSchema = z.object(compensatoryControlBaseShape)
    .superRefine(validateCompensatoryNature);

export const UpdateBigdesCompensatoryControlSchema = z.object({
    ...compensatoryControlBaseShape,
    name: compensatoryControlBaseShape.name.optional(),
    controlNo: compensatoryControlBaseShape.controlNo.optional(),
    definition: compensatoryControlBaseShape.definition.optional(),
    nature: compensatoryControlBaseShape.nature.optional(),
}).superRefine((data, ctx) => {
    if (data.nature != null) {
        validateCompensatoryNature(data, ctx);
    }
});
